import { Button, message, Spin, Table } from 'antd'
import { SDrawerOrModal, SLowcodeList, STags } from 'shj-components'
import FailedDataModal from '../failedDataModal'
import { useState } from 'react'
import { config } from './config'
import { useRef } from 'react'
import { apiData2Table } from '@/utils/data'
import { findResponseListByPage, sndNotifyForHandle } from '@/services/product'

export default function HistoryModal(props: any) {
  const { open, loading, onCancel, onSubmit, title } = props
  const [failedDataModalOpen, setFailedDataModalOpen] = useState(false)
  const [sendLoading, setSendLoading] = useState(false)
  const [record, setRecord] = useState<any>()
  const listRef = useRef()
  const fetchList = values => {
    const { current, pageSize, ...rest } = values
    return new Promise((resolve, reject) => {
      findResponseListByPage({
        current: current,
        pageSize,
        ...rest.query,
      })
        .then(res => {
          resolve(apiData2Table(res))
        })
        .catch(reject)
    })
  }
  const clickToNotice = record => {
    setSendLoading(true)
    sndNotifyForHandle({
      data: {
        productSyncLogId: record.id,
      },
    })
      .then((res: any) => {
        console.log(res,'11111');
        if (!res?.successFlag) {
          message.error('当前数据10分钟内已通知过3次，请稍后重试！')
        }else{
          message.success('通知成功！')
        }
      })
      .finally(() => {
        setSendLoading(false)
      })
  }
  const extensions = {
    request: { fetchList },
    events: {},
    status: {},
    customRender: {
      statusRender(v: string, record: Record<string, any>) {
        return v === '处理完成' ? (
          <STags label="处理完成" bgColor="#bcebdc" fontColor="#2ab7af"></STags>
        ) : (
          <STags label="处理中" bgColor="#dde7fe" fontColor="#8986f8"></STags>
        )
      },
      failureSizeRender(v: any, record: Record<string, any>) {
        if (Number(v) > 0) {
          return (
            <a
              onClick={() => {
                if (Number(v) > 0) {
                  setRecord(record)
                  setFailedDataModalOpen(true)
                }
              }}
            >
              {v}
            </a>
          )
        } else {
          return <span>{v}</span>
        }
      },
      handleRender(v: any, record: Record<string, any>) {
        if (record.resultStatusName === '处理完成' && record.successSize > 0) {
          return (
            <Button type="link" onClick={() => clickToNotice(record)}>
              通知产品研发
            </Button>
          )
        }
      },
    },
    scroll: { y: 550 },
  }
  return (
    <SDrawerOrModal
      mode="modal"
      open={open}
      loading={loading}
      onCancel={() => onCancel(false)}
      onOk={onSubmit}
      title={title}
      width={1000}
      antdProps={{ footer: null }}
    >
      <Spin spinning={sendLoading}>
        <SLowcodeList ref={listRef} searchMode="group" config={config} {...extensions} />
        {failedDataModalOpen && (
          <FailedDataModal
            open={failedDataModalOpen}
            title="失败数据"
            record={record}
            setOpen={setFailedDataModalOpen}
          ></FailedDataModal>
        )}
      </Spin>
    </SDrawerOrModal>
  )
}
